import styled from '@emotion/styled';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';

function FaqFeedbackPrompt(props: BaseMsgProps) {
  return (
    <MessageExtendComplex
      {...props}
      content={
        <Container>
          <div>Was this answer helpful？</div>
          <ul>
            <li>YES</li>
            <li>NO</li>
          </ul>
        </Container>
      }
    />
  );
}

const Container = styled.div`
  max-width: 450px;
  border-radius: 4px;
  background: var(--fett-bg-panel);
  > div {
    padding: 8px 12px;
    border-bottom: solid 1px var(--fett-border-default);
  }
  > ul {
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
    > li {
      flex: 1 0 0;
      padding: 8px 0;
      text-align: center;
      color: var(--fett-text-quaternary);
      & + li {
        border-left: solid 1px var(--fett-border-default);
      }
    }
  }
`;

export default FaqFeedbackPrompt;
